import React from "react";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import Seo from "@/components/Seo";
import ContactForm from "@/components/ContactForm";
import { BUSINESS } from "@/lib/constants";

export default function ContactPage() {
    const mapsQuery = encodeURIComponent("470 St Kilda Road, Melbourne VIC 3004");
    return (
        <div data-testid="page-contact" className="pt-20">
            <Seo
                title="Contact Finance Wealth — Australia-Wide Mortgage Broker"
                description="Speak with Gurpreet Singh at Finance Wealth — mortgage broker helping borrowers Australia-wide. Registered office at 470 St Kilda Road, Melbourne. Phone 0493 659 554."
                keywords="contact mortgage broker Australia, Finance Wealth contact, online mortgage broker, Gurpreet Singh phone"
            />
            <section className="bg-[#F3F1EA]">
                <div className="container-prose py-20 md:py-28">
                    <div className="max-w-3xl">
                        <div className="overline">Get in touch</div>
                        <h1 className="mt-4 font-serif text-5xl sm:text-6xl tracking-tight leading-[1.02] text-[#1A362B] font-medium">
                            Let's talk about your finance.
                        </h1>
                        <div className="divider-thin my-8" />
                        <p className="text-lg text-[#1C1C1C]/75 leading-relaxed font-light">
                            Send us a few details and Gurpreet will reach out personally — typically within one
                            business day.
                        </p>
                    </div>
                </div>
            </section>

            <section className="bg-background">
                <div className="container-prose py-24 grid grid-cols-1 lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-5 space-y-8">
                        <div>
                            <div className="overline">Office</div>
                            <h2 className="mt-3 font-serif text-3xl text-[#1A362B]">{BUSINESS.brand}</h2>
                            <p className="text-sm text-[#1C1C1C]/60 mt-1">{BUSINESS.broker} · {BUSINESS.role}</p>
                        </div>

                        <ul className="space-y-5 text-sm">
                            <li className="flex gap-4">
                                <MapPin className="w-5 h-5 text-[#C69C6D] shrink-0 mt-0.5" />
                                <div data-testid="contact-address">
                                    <div className="font-medium text-[#1A362B]">Visit us</div>
                                    <div className="text-[#1C1C1C]/70 leading-relaxed mt-1">
                                        {BUSINESS.addressLine1}<br />
                                        {BUSINESS.addressLine2}<br />
                                        {BUSINESS.addressLine3}
                                    </div>
                                </div>
                            </li>
                            <li className="flex gap-4">
                                <Phone className="w-5 h-5 text-[#C69C6D] shrink-0 mt-0.5" />
                                <div>
                                    <div className="font-medium text-[#1A362B]">Call</div>
                                    <a href={`tel:${BUSINESS.phoneTel}`} data-testid="contact-phone-link" className="text-[#1C1C1C]/70 hover:text-[#1A362B] transition">{BUSINESS.phone}</a>
                                </div>
                            </li>
                            <li className="flex gap-4">
                                <Mail className="w-5 h-5 text-[#C69C6D] shrink-0 mt-0.5" />
                                <div>
                                    <div className="font-medium text-[#1A362B]">Email</div>
                                    <a href={`mailto:${BUSINESS.email}`} data-testid="contact-email-link" className="text-[#1C1C1C]/70 hover:text-[#1A362B] transition break-all">{BUSINESS.email}</a>
                                </div>
                            </li>
                            <li className="flex gap-4">
                                <Clock className="w-5 h-5 text-[#C69C6D] shrink-0 mt-0.5" />
                                <div>
                                    <div className="font-medium text-[#1A362B]">Hours</div>
                                    <div className="text-[#1C1C1C]/70 leading-relaxed mt-1">
                                        Monday – Friday · 9:00 – 18:00<br />
                                        Saturday · By appointment
                                    </div>
                                </div>
                            </li>
                        </ul>

                        <div className="aspect-video w-full overflow-hidden rounded-sm border border-border">
                            <iframe
                                title="Finance Wealth office location"
                                data-testid="contact-map"
                                src={`https://www.google.com/maps?q=${mapsQuery}&output=embed`}
                                width="100%"
                                height="100%"
                                style={{ border: 0 }}
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            />
                        </div>
                    </div>

                    <div className="lg:col-span-7">
                        <ContactForm />
                    </div>
                </div>
            </section>
        </div>
    );
}
